// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"c67eaa44","453":"162c0fd5","481":"215e294d","636":"3a67ab88","751":"90385123","850":"8b1d22ac","895":"5f5fd711"}[chunkId] + ".chunk.js";
};